<template>
  <div class="hierarchyFilter">
    <h6 :style="classStyle">
      {{ hierarchy.class }}
    </h6>
    <b-container class="m-0">
      <b-row

        v-for="(filter, indexLevel) in hierarchy.levelList"
        :key="filter.id"
        class="mb-2"
      >
        <MultiSelect
          :id="filter.id"
          v-model="filters[filter.id]"
          :options="filterOptionsByIndex(indexLevel)"
          :multiple="true"
          :clear-on-select="false"
          :placeholder="filter.description"
          label="name"
          track-by="id"
          :max-height="150"
          :preselect-first="true"
          :hide-selected="true"
          :show-labels="false"
          :disabled="filterIsDisabled(filter.id)"
          @remove="removeOptions"
        />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
  name: 'FilterHierarchy',
  components: {
    MultiSelect
  },
  props: {
    hierarchy: {
      type: Object,
      required: true
    },
    underlinedClass: {
      type: Boolean,
      default: true
    },
    selectedFiltersOptionIds: {
      type: Object,
      default: () => {}
    },
    disabledFilters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      filters: {}
    }
  },
  computed: {
    classStyle () {
      return this.underlinedClass ? 'border-bottom: 1px solid #251e63;' : ''
    },
    getAvailableOptions () {
      return (parentIds, options) => {
        if (parentIds.length === 0) return []
        else return options.filter((option) => parentIds.includes(option.parent_id))
      }
    },
    filterOptionsByIndex () {
      return (filterIndex) => {
        if (filterIndex === 0) return this.hierarchy.levelList[filterIndex].options
        else return this.getAvailableOptions(this.getFilterParentSelectedOptionsIds(filterIndex), this.hierarchy.levelList[filterIndex].options)
      }
    }
  },
  created () {
    this.setFiltersReactivity()
  },
  methods: {
    getFilterParentSelectedOptionsIds (myFilterIndex) {
      const filterParentSelectedOptions = this.getFilterParentSelectedOptions(myFilterIndex)
      return filterParentSelectedOptions.map((selection) => selection.id)
    },
    getFilterParentSelectedOptions (myFilterIndex) {
      const filterParent = this.getFilterParent(myFilterIndex)
      return this.filters[filterParent.id]
    },
    getFilterParent (myFilterIndex) {
      return this.hierarchy.levelList[myFilterIndex - 1]
    },
    removeOptions (removedOption) {
      const hasNoChild = removedOption.child_level_id === 'None' || removedOption.child_level_id === null
      if (hasNoChild) return
      this.updateHierarchy(removedOption)
    },
    updateHierarchy (removedOption) {
      this.removeGrandson(removedOption)
      this.removeChildOptions(removedOption)
    },
    removeGrandson (parentRemovedOption) {
      const childFilter = this.filters[parentRemovedOption.child_level_id]
      const selectedOptionsToBePopped = childFilter.filter((selectedOption) => selectedOption.parent_id === parentRemovedOption.id)
      selectedOptionsToBePopped.forEach((selectedOptionToBePopped) => this.removeOptions(selectedOptionToBePopped))
    },
    removeChildOptions (parentRemovedOption) {
      const childFilter = this.filters[parentRemovedOption.child_level_id]
      const filteredChildSelectedOptions = childFilter.filter((selectedOption) => selectedOption.parent_id !== parentRemovedOption.id)
      this.filters[parentRemovedOption.child_level_id] = filteredChildSelectedOptions
    },
    setFiltersReactivity () {
      this.hierarchy.levelList.forEach((level, index) => {
        let selectedFilterOptions = []
        if (this.selectedFiltersOptionIds[level.id]) {
          const selectedFilterOptionIds = this.selectedFiltersOptionIds[level.id]
          selectedFilterOptions = this.hierarchy.levelList[index].options.filter((option) => selectedFilterOptionIds.includes(option.id))
        }
        this.$set(this.filters, level.id, selectedFilterOptions)
      })
    },
    filterIsDisabled (filterId) {
      return !!this.disabledFilters.find(disabledFilterId => disabledFilterId === filterId)
    }
  }
}
</script>

<style scoped>
  .hierarchyFilter >>> .multiselect--disabled .multiselect__input{
    display: none
  }
</style>



// WEBPACK FOOTER //
// src/app/shared/components/FilterHierarchy.vue